import { IPublicClientApplication, AccountInfo, InteractionRequiredAuthError } from '@azure/msal-browser';
import { isJwtExpiringSoon } from './authHelper';

class TokenService {
    private readonly STORAGE_KEY = 'selfServiceIdToken';
    
    async getValidToken(
        msalInstance: IPublicClientApplication, 
        account: AccountInfo
    ): Promise<string | null> {
        const cached = this.getCachedToken();
        
        if (cached && !isJwtExpiringSoon(cached, 5)) {
            return cached;
        }
        
        return await this.refreshToken(msalInstance, account);
    }
    
    getCachedToken(): string | null {
        return localStorage.getItem(this.STORAGE_KEY);
    }
    
    storeToken(token: string): void {
        localStorage.setItem(this.STORAGE_KEY, token);
    }
    
    clearToken(): void {
        localStorage.removeItem(this.STORAGE_KEY);
    }
    
    private async refreshToken(
        msalInstance: IPublicClientApplication,
        account: AccountInfo
    ): Promise<string | null> {
        try {
            const response = await msalInstance.acquireTokenSilent({
                scopes: ["user.read"],
                account: account,
            });
            
            if (response.idToken) {
                this.storeToken(response.idToken);
                return response.idToken;
            }
            
            return null;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                try {
                    await msalInstance.acquireTokenRedirect({
                        scopes: ["user.read"],
                        account: account,
                    });
                    return null;
                } catch (redirectError) {
                    console.error('Token acquisition failed:', redirectError);
                    return null;
                }
            } else {
                console.error('Silent token acquisition failed:', error);
                return null;
            }
        }
    }
}

export const tokenService = new TokenService();
